import type { IndexModel } from "@/api/models"

/**
 * Find the library whose id or display_name contains the given keyword.
 *
 * Used by the quick-start modal and CV matching section to auto-detect
 * which library to search for CVs. The keyword comes from the route
 * config override `cvLibraryKeyword` (defaults to `"cv"`).
 */
export function detectCvLibrary(libraries: IndexModel[], keyword: string): IndexModel | undefined {
  return libraries.find(
    (lib) =>
      lib.id.toLowerCase().includes(keyword) || lib.display_name.toLowerCase().includes(keyword)
  )
}
